<template>
  <v-form ref="helpMenuForm" v-model="valid" lazy-validation>
    <v-container>
      <h2>Soru Düzenle</h2>

      <v-row style="margin-top: 50px;">
        <v-col cols="12" md="12">
          <h4>Soru</h4>
          <v-text-field
            v-model="contentData.title"
            maxlength="120"
            counter="120"
            :rules="titleRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12">
          <h4>Cevap</h4>
          <v-textarea
            maxlength="10000"
            rows="1"
            auto-grow
            v-model="contentData.description"
            :rules="descriptionRules"
            required
          ></v-textarea>
        </v-col>

      </v-row>
      <v-row style="margin-top: 50px;">
        <v-col cols="12" md="12">
          <h4>Soru[EN]</h4>
          <v-text-field
            v-model="contentData.titleEn"
            maxlength="120"
            counter="120"
            :rules="titleRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12">
          <h4>Cevap[EN]</h4>
          <v-textarea
            maxlength="10000"
            rows="1"
            auto-grow
            v-model="contentData.descriptionEn"
            :rules="descriptionRules"
            required
          ></v-textarea>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <h4>Kategori</h4>

          <v-select
            v-model="contentData.helpMenuId"
            :items="helpMenuCategoryList"
            item-text="title"
            item-value="id"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <h4>Öncelik
            <v-icon
              style="font-size: 17px;"
              v-if="!alertPriority"
              color="#4d48f9"
              @click="alertPriority = !alertPriority"
            >
              info
            </v-icon>

            <v-alert
              v-model="alertPriority"
              border="left"
              close-text="Close Alert"
              color="#4d48f9"
              dark
              dismissible
            >
              Sorunun uygulamadaki sırasını belirtir.
            </v-alert>
          </h4>
          <v-text-field
            v-model="contentData.priority"
            type="number"
            min="0"
            required
            @input="handleInput"
          ></v-text-field>
        </v-col>


        <v-col cols="12" md="3">
          <h4>Aktif/Pasif</h4>
          <v-checkbox v-model="contentData.active" color="#4d48f9"></v-checkbox>
        </v-col>

      </v-row>

      <v-row>
        <v-col cols="12" md="2">
          <v-btn
            depressed
            color="#4d48f9"
            style="text-transform: none !important; float: left; color: white;"
            @click="helpMenuContentAdd()"
          >GÜNCELLE
          </v-btn>
        </v-col>
        <v-col cols="12" md="2">
          <v-btn
            depressed
            color="#d9534f"
            style="text-transform: none !important; float: left; color: white;"
            @click.stop="dialogDelete = true"

          >SİL
          </v-btn>
        </v-col>
      </v-row>

      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline"
          >Lütfen alanları kontrol edin
          </v-card-title
          >

          <v-card-text>
            <ul>
              <li v-for="errorList in this.errorList" :key="errorList">
                {{ errorList }}
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDelete" max-width="390">
        <v-card>
          <v-card-title class="headline">Uyarı</v-card-title>

          <v-card-text>Silmek istediğime emin misin?</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              style="color:#1565C0 !important;"
              text
              @click="dialogDelete = false"
            >Vazgeç</v-btn>

            <v-btn
              color="red"
              style="color:#d9534f !important;"
              text
              @click="helpMenuContentDelete()"
            >SİL</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- <v-row>

      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "helpMenuContent",
  data: () => ({
    alert: false,
    alertPriority: false,
    alertLink: false,
    valid: true,
    titleRules: [
      (v) => !!v || "Soru alanı zorunludur.",
      (v) => !!v && v.length <= 120 || "Maksimum 120 karakter olmalıdır."
    ],
    descriptionRules: [
      (v) => !!v || "Cevap alanı zorunludur."
    ],
    noRule: [],
    helpMenuContent: {
      title: "",
      titleEn: "",
      description: "",
      descriptionEn: "",
      helpMenuId: 0,
      active: true,
      priority: 0
    },
    menu: false,
    errorList: [],
    dialog: false,
    dialogDelete:false
  }),
  computed: mapGetters(["helpMenuCategoryList", "contentData"]),

  created() {

    this.getHelpMenuCategoryList();
    const id = this.$route.params.id;
    this.getHelpMenuContent(id);
  },
  methods: {
    ...mapActions(["updateContent", "getHelpMenuCategoryList", "getHelpMenuContent", "deleteContent"]),

    routeList() {
      this.$router.push("/dashboard/helpMenuContents");
    },
    handleInput(item) {
      if (item.includes(".")) this.campaign.userCount = item.replace(".", "");
    },
    helpMenuContentDelete() {
      const id = this.$route.params.id;
      this.deleteContent(id).then((response) => {
        if (response.processStatus === "Success") {
          this.routeList();
        } 
      }).catch((err) => {
        alert(err.response.friendlyMessage.message);
      });

    },

    helpMenuContentAdd() {

      if (this.$refs.helpMenuForm.validate()) {
        this.snackbar = true;
        this.updateContent(this.contentData)
          .then((response) => {
            if (response.processStatus === "Success") {
              this.routeList();
            } else {
              alert(response.friendlyMessage.message);
            }
          })
          .catch((err) => {
            alert(err);
          });
      } else {

        let errors = [];
        let x = document.getElementsByClassName("v-messages__message");
        console.log(x);
        for (let i = 0; i < x.length; i++) errors.push(x[i].innerHTML);
        this.errorList = errors;
        this.dialog = true;
      }
    }
  }

};
</script>
